import { REPORT_APPLICATION_STATUS_E, REPORT_APPLICATION_TYPE_E, REPORT_DATE_TYPE_E, REPORT_GROUP_BY_E, REPORT_LEVEL_E, REPORT_SORT_BY_E, REPORT_RISK_LEVEL_E, REPORT_FORMAT_E, REPORT_CASHFLOW_E } from "@Broker/@Types/reports/types";
import moment from "moment";
const state = {
  firmStatisticsStructure: {
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    selectedLevel: REPORT_LEVEL_E.EMPTY,
    selectedAgents: "",
    selectedApplicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    selectedFormat: "",
    filterForAIR: false
  },
  renewalTrackingStructure: {
    level: REPORT_LEVEL_E.EMPTY,
    agent: "",
    format: "",
    lender: "",
    mortgageType: "",
    requestType: "all",
    dateFrom: "",
    dateTo: "",
    groupBy: REPORT_GROUP_BY_E.AGENT,
    sortBy: [REPORT_SORT_BY_E.LENDER, REPORT_SORT_BY_E.APPLICATION_ID]
  },
  applicationSummaryStructure: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    lender: "all",
    applicationStatus: REPORT_APPLICATION_STATUS_E.ALL,
    applicationType: REPORT_APPLICATION_TYPE_E.ALL,
    referralSource: "all",
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    groupBy: REPORT_GROUP_BY_E.APPLICATION_STATUS,
    sortByPrimary: REPORT_SORT_BY_E.LENDER,
    sortBySecondary: REPORT_SORT_BY_E.APPLICANT_SURNAME,
    format: ""
  },
  lenderTransactionStructure: {
    level: REPORT_LEVEL_E.EMPTY,
    agent: "",
    format: "",
    lender: "",
    applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    filterForAIR: false,
    groupBy: REPORT_GROUP_BY_E.APPLICATION_STATUS,
    sortBy: [REPORT_SORT_BY_E.LENDER, REPORT_SORT_BY_E.APPLICANT_SURNAME]
  },
  commissionsStructure: {
    dateType: REPORT_DATE_TYPE_E.CLOSING_DATE,
    dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
    dateTo: moment().endOf("month").format("YYYY-MM-DD"),
    level: REPORT_LEVEL_E.BROKERAGE,
    agents: "all",
    applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    format: REPORT_FORMAT_E.PDF,
    feeType: "all",
    deductionType: "all",
    cashflow: REPORT_CASHFLOW_E.PAID,
    groupBy: REPORT_GROUP_BY_E.APPLICATION_STATUS,
    sortByPrimary: REPORT_SORT_BY_E.EMPTY,
    sortBySecondary: REPORT_SORT_BY_E.EMPTY
  },
  riskLevelStructure: {
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    selectedLevel: REPORT_LEVEL_E.EMPTY,
    selectedAgents: "",
    selectedApplicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    selectedFormat: "",
    selectedRiskLevels: REPORT_RISK_LEVEL_E.EMPTY
  },
  responseMessage: "",
  reportsHistoryLoader: false
};
export const REPORT_DEFAULT_PREFERENCES_STRUCTURE = {
  applicationSummary: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    format: "",
    lender: "",
    applicationStatus: REPORT_APPLICATION_STATUS_E.ALL,
    applicationType: REPORT_APPLICATION_TYPE_E.ALL,
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    referralSource: "all",
    groupBy: REPORT_GROUP_BY_E.APPLICATION_STATUS,
    sortByPrimary: REPORT_SORT_BY_E.LENDER,
    sortBySecondary: REPORT_SORT_BY_E.APPLICANT_SURNAME
  },
  firmStatistics: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    format: "",
    applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    annualInformationReturn: false
  },
  renewalTracking: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    format: "",
    lender: "",
    mortgageType: "",
    requestType: "all",
    maturityDateFrom: "",
    maturityDateTo: "",
    groupBy: REPORT_GROUP_BY_E.AGENT,
    sortByPrimary: REPORT_SORT_BY_E.LENDER,
    sortBySecondary: REPORT_SORT_BY_E.APPLICATION_ID
  },
  lenderTransactions: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    format: "",
    lender: "",
    applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    annualInformationReturn: false,
    groupBy: REPORT_GROUP_BY_E.APPLICATION_STATUS,
    sortByPrimary: REPORT_SORT_BY_E.LENDER,
    sortBySecondary: REPORT_SORT_BY_E.APPLICANT_SURNAME
  },
  commissions: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    format: "",
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    feeType: "all",
    deductionType: "all",
    cashflow: REPORT_CASHFLOW_E.PAID,
    groupBy: REPORT_GROUP_BY_E.EMPTY,
    sortByPrimary: REPORT_SORT_BY_E.EMPTY,
    sortBySecondary: REPORT_SORT_BY_E.EMPTY
  },
  riskLevel: {
    level: REPORT_LEVEL_E.EMPTY,
    agents: "",
    format: "",
    applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
    dateType: REPORT_DATE_TYPE_E.EMPTY,
    dateFrom: "",
    dateTo: "",
    riskLevels: REPORT_RISK_LEVEL_E.EMPTY
  }
};
export default state;